// ------ button
import { disabled } from './button';
import { activeOpacity } from './button';
import { tvParallaxProperties } from './button';
import { hasTVPreferredFocus } from './button';
import { nextFocusDown } from './button';
import { nextFocusLeft } from './button';
import { nextFocusRight } from './button';
import { nextFocusUp } from './button';

// ------ image
import { accessibilityLabel } from './image';
import { alt } from './image';
import { blurRadius } from './image';
import { capInsets } from './image';
import { crossOrigin } from './image';
import { defaultSource } from './image';
import { fadeDuration } from './image';
import { height } from './image';
import { loadingIndicatorSource } from './image';
import { objectFit } from './image';
import { onError } from './image';
import { onLayout } from './image';
import { onLoad } from './image';
import { onLoadEnd } from './image';
import { onLoadStart } from './image';

// ------ inputText
import { editable } from './inputText';
import { placeholder } from './inputText';
import { placeholderTextColor } from './inputText';
import { onFocus } from './inputText';
import { onBlur } from './inputText';

// ------ list
import { ItemSeparatorComponent } from './list';
import { ListFooterComponentStyle } from './list';
import { ListHeaderComponent } from './list';
import { ListHeaderComponentStyle } from './list';
import { columnWrapperStyle } from './list';
import { extraData } from './list';
import { getItemLayout } from './list';
import { horizontal } from './list';
import { initialScrollIndex } from './list';
import { inverted } from './list';
import { keyExtractor } from './list';
import { onRefresh } from './list';
import { ListEmptyComponent } from './list';
import { ListFooterComponent } from './list';
import { onEndReachedThreshold } from './list';
import { onEndReached } from './list';
import { numColumns } from './list';

// ------ loader
import { size } from './loader';
import { color } from './loader';

// ------ scrollview
import { alwaysBounceHorizontal } from './scrollview';
import { alwaysBounceVertical } from './scrollview';
import { bounces } from './scrollview';
import { bouncesZoom } from './scrollview';
import { automaticallyAdjustContentInsets } from './scrollview';
import { automaticallyAdjustKeyboardInsets } from './scrollview';
import { automaticallyAdjustsScrollIndicatorInsets } from './scrollview';
import { canCancelContentTouches } from './scrollview';
import { centerContent } from './scrollview';
import { contentContainerStyle } from './scrollview';
import { contentInset } from './scrollview';
import { contentInsetAdjustmentBehavior } from './scrollview';
import { contentOffset } from './scrollview';
import { decelerationRate } from './scrollview';
import { directionalLockEnabled } from './scrollview';
import { disableIntervalMomentum } from './scrollview';
import { disableScrollViewPanResponder } from './scrollview';
import { endFillColor } from './scrollview';
import { fadingEdgeLength } from './scrollview';
import { horizontal2 } from './scrollview';
import { indicatorStyle } from './scrollview';
import { invertStickyHeaders } from './scrollview';
import { keyboardDismissMode } from './scrollview';
import { keyboardShouldPersistTaps } from './scrollview';
import { maintainVisibleContentPosition } from './scrollview';
import { maximumZoomScale } from './scrollview';
import { minimumZoomScale } from './scrollview';
import { nestedScrollEnabled } from './scrollview';
import { overScrollMode } from './scrollview';
import { pagingEnabled } from './scrollview';
import { persistentScrollbar } from './scrollview';
import { pinchGestureEnabled } from './scrollview';
import { removeClippedSubviews } from './scrollview';
import { scrollEnabled } from './scrollview';
import { scrollEventThrottle } from './scrollview';
import { scrollIndicatorInsets } from './scrollview';
import { scrollToOverflowEnabled } from './scrollview';
import { scrollsToTop } from './scrollview';
import { showsHorizontalScrollIndicator } from './scrollview';
import { ShowsVerticalScrollIndicator } from './scrollview';
import { snapToAlignment } from './scrollview';
import { snapToEnd } from './scrollview';
import { snapToInterval } from './scrollview';
import { snapToOffsets } from './scrollview';
import { snapToStart } from './scrollview';
import { stickyHeaderHiddenOnScroll } from './scrollview';
import { stickyHeaderIndices } from './scrollview';
import { zoomScale } from './scrollview';
import { onScrollEndDrag } from './scrollview';
import { scrollPerfTagg } from './scrollview';
import { refreshControl } from './scrollview';
import { onContentSizeChange } from './scrollview';
import { onMomentumScrollBegin } from './scrollview';
import { onMomentumScrollEnd } from './scrollview';
import { onScroll } from './scrollview';
import { onScrollBeginDrag } from './scrollview';
import { onScrollToTop } from './scrollview';
import { style } from './scrollview';

// ------ text
import { pt15 } from './text';
import { pt16 } from './text';
import { pt17 } from './text';
import { pt18 } from './text';
import { pt19 } from './text';
import { pt20 } from './text';
import { pt21 } from './text';
import { pt22 } from './text';
import { pt23 } from './text';
import { pt24 } from './text';
import { pt25 } from './text';

// ------ view
import { pv15 } from './view';
import { pv16 } from './view';
import { pv17 } from './view';
import { pv18 } from './view';
import { pv19 } from './view';
import { pv20 } from './view';
import { pv21 } from './view';
import { pv22 } from './view';

export const props = {
  alwaysBounceHorizontal,
  alwaysBounceVertical,
  bounces,
  bouncesZoom,
  automaticallyAdjustContentInsets,
  automaticallyAdjustKeyboardInsets,
  automaticallyAdjustsScrollIndicatorInsets,
  canCancelContentTouches,
  centerContent,
  contentContainerStyle,
  contentInset,
  contentInsetAdjustmentBehavior,
  contentOffset,
  decelerationRate,
  directionalLockEnabled,
  disableIntervalMomentum,
  disableScrollViewPanResponder,
  endFillColor,
  fadingEdgeLength,
  horizontal,
  indicatorStyle,
  invertStickyHeaders,
  keyboardDismissMode,
  keyboardShouldPersistTaps,
  maintainVisibleContentPosition,
  maximumZoomScale,
  minimumZoomScale,
  nestedScrollEnabled,
  overScrollMode,
  pagingEnabled,
  persistentScrollbar,
  pinchGestureEnabled,
  removeClippedSubviews,
  scrollEnabled,
  scrollEventThrottle,
  scrollIndicatorInsets,
  scrollToOverflowEnabled,
  scrollsToTop,
  showsHorizontalScrollIndicator,
  ShowsVerticalScrollIndicator,
  snapToAlignment,
  snapToEnd,
  snapToInterval,
  snapToOffsets,
  snapToStart,
  stickyHeaderHiddenOnScroll,
  stickyHeaderIndices,
  zoomScale,
  onScrollEndDrag,
  scrollPerfTagg,
  refreshControl,
  onContentSizeChange,
  onMomentumScrollBegin,
  onMomentumScrollEnd,
  onScroll,
  onScrollBeginDrag,
  onScrollToTop,
  style,
  size,
  color,
  ItemSeparatorComponent,
  ListFooterComponentStyle,
  ListHeaderComponent,
  ListHeaderComponentStyle,
  columnWrapperStyle,
  extraData,
  getItemLayout,
  horizontal2,
  initialScrollIndex,
  inverted,
  keyExtractor,
  onRefresh,
  ListEmptyComponent,
  ListFooterComponent,
  onEndReachedThreshold,
  onEndReached,
  numColumns,
  accessibilityLabel,
  alt,
  blurRadius,
  capInsets,
  crossOrigin,
  defaultSource,
  fadeDuration,
  height,
  loadingIndicatorSource,
  objectFit,
  onError,
  onLayout,
  onLoad,
  onLoadEnd,
  onLoadStart,
  disabled,
  activeOpacity,
  tvParallaxProperties,
  hasTVPreferredFocus,
  nextFocusDown,
  nextFocusLeft,
  nextFocusRight,
  nextFocusUp,
  editable,
  placeholder,
  placeholderTextColor,
  onFocus,
  onBlur,
  pt15,
  pt16,
  pt17,
  pt18,
  pt19,
  pt20,
  pt21,
  pt22,
  pt23,
  pt24,
  pt25,

  pv15,
  pv16,
  pv17,
  pv18,
  pv19,
  pv20,
  pv21,
  pv22,
};
